import { FC } from 'react';
import { TabsContent, TabsList, TabsTrigger } from '../../ui/tabs';
import { cn } from 'lib/utils';
import { uiSimpleBox } from 'components/BionicUI/CutCorners';

export type CardTab = {
  title: string;
  content: JSX.Element;
  key: string;
};

export const TabsButtons: FC<{
  tabs: CardTab[];
  handleTabClick?: () => void;
}> = ({ tabs, handleTabClick = () => {} }) => {
  return (
    <TabsList className={`grid-cols-${tabs.length}`}>
      <div
        className={cn(
          'block absolute top-0 left-0 w-full h-full bg-gradient-to-b from-white/10 to-white/0',
          uiSimpleBox.border
        )}
      />
      {tabs.map((tab) => (
        <TabsTrigger
          key={`tabs_trigger_${tab.key}`}
          value={tab.title}
          onClick={handleTabClick}
        >
          {tab.title}
        </TabsTrigger>
      ))}
    </TabsList>
  );
};

export const TabsContents: FC<{
  tabs: CardTab[];
  twTabsContainer?: string;
}> = ({ tabs, twTabsContainer }) => {
  return (
    <>
      {tabs.map((tab) => (
        <TabsContent
          key={`tabs_content_${tab.key}`}
          value={tab.title}
          className={cn('pt-[70px] @lg:pt-0', twTabsContainer)}
        >
          {tab.content}
        </TabsContent>
      ))}
    </>
  );
};
